import React, { FC } from 'react';
import { FormCheck } from 'react-bootstrap';

export interface Props {
  id: string;
  enabled?: boolean;
  label?: string | React.ReactNode;
  value: boolean | undefined;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  rest?: Record<string, unknown>;
  style?: React.CSSProperties;
  readOnlyMode?: boolean;
}

const CheckboxInput: FC<Props> = ({ id, value, enabled = true, onChange, label, rest, style, readOnlyMode }: Props) => {
  return (
    <FormCheck
      id={id}
      name={id}
      checked={value}
      label={label}
      disabled={!enabled || readOnlyMode}
      onChange={onChange}
      style={style}
      {...rest}
    />
  );
};

export default CheckboxInput;
